import { toast } from "react-toastify";
import { API, get } from "../../../../config";
import { useCallback, useEffect, useState } from "react";

export const getUsersPopupDetail = async (usersId, isRecentActivity) => {
  try {
    if (isRecentActivity) {
      const { data } = await get(`${API.GET_ADMIN_USER_LIST}/${usersId}`);
      return data.data;
    } else {
      const { data } = await get(`${API.GET_ADMIN_USER_LIST}/${usersId}`);
      return data.data;
    }
  } catch (error) {
    if (error?.response?.data?.errors) {
      Object.keys(error?.response?.data?.errors).forEach((key) => {
        toast.error(error?.response?.data?.errors[key][0]);
      });
    } else {
      toast.error(error?.message);
    }
    return null;
  }
};

export const getUsersDetail = async (usersId) => {
  try {
    const { data } = await get(`${API.GET_ADMIN_USER_LIST}/` + usersId);
    return data.data;
  } catch (e) {
    return null;
  }
};

export const useAdminRoleList = () => {
  const [roleList, setRoleList] = useState([]);
  const [roleLoading, setRoleLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setRoleLoading(true);
      const { data } = await get(`${API.GET_ROLE_LIST}?page=1&limit=-1&type=Admin&status=1`);
      setRoleLoading(false);
      setRoleList(data.data.data);
    } catch (e) {
      setRoleList([]);
      setRoleLoading(false);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return {
    roleList,
    roleLoading,
  };
};
